import { AiMagicIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Sparkles = /* @__PURE__ */ createIcon(AiMagicIcon, 'Sparkles');
